<div
  class="popup-overlay"
  *ngIf="
    popupSetting.show &&
    (popupSetting.type === PopupSettingType.IMAGE_LIBRARY ||
      popupSetting.type === PopupSettingType.IMAGE_WIDGET ||
      popupSetting.type === PopupSettingType.LOGO_WIDGET ||
      popupSetting.type === PopupSettingType.PAGE_BACKGROUND)
  "
></div>
@if (popupSetting.type !== PopupSettingType.ICON_LIBRARY) {
<div
  *ngIf="popupSetting.show"
  class="popup-wrapper"
  [class.img-upload-popup]="
    popupSetting.type === PopupSettingType.IMAGE_LIBRARY ||
    popupSetting.type === PopupSettingType.IMAGE_WIDGET ||
    popupSetting.type === PopupSettingType.LOGO_WIDGET ||
    popupSetting.type === PopupSettingType.PAGE_BACKGROUND ||
    popupSetting.type === PopupSettingType.CARD
  "
>
  <div *ngIf="errorMessages.length > 0" class="popup-error-wrapper">
    <div class="popup-error-message custom-scrollbar" *ngFor="let message of errorMessages">
      {{ message }}
    </div>
  </div>
  <div class="popup-header">
    <img src="/assets/images/image-thumbnail.svg" alt="thumb" class="img-fluid" />
    <h3>
      {{ 'Upload your Image' }}
    </h3>
  </div>
  <div class="popup-body">
    <div
      *ngIf="
        popupSetting.type === PopupSettingType.IMAGE_LIBRARY ||
        popupSetting.type === PopupSettingType.IMAGE_WIDGET ||
        popupSetting.type === PopupSettingType.LOGO_WIDGET ||
        popupSetting.type === PopupSettingType.PAGE_BACKGROUND ||
        popupSetting.type === PopupSettingType.CARD
      "
      class="input-wrap"
      finxoneWorkflowFrontendImageUploadDirective
      (fileDropped)="onFileDropped($event)"
    >
      <input
        type="file"
        #fileDropRef
        id="fileDropRef"
        [accept]="imageAcceptanceType"
        (change)="fileBrowseHandler($event)"
      />
      <h3>
        Drag and drop file here or
        <label for="fileDropRef">Choose file</label> to upload
      </h3>
      <span>2 MB Max Size </span>
    </div>

    <div class="separator">Or</div>
    <div class="default-logos">
      <div [class.mb-2]="popupSetting.type === PopupSettingType.IMAGE_LIBRARY" class="title">
        {{ popupSetting.type === PopupSettingType.IMAGE_LIBRARY ? 'Image Library' : 'Select from library' }}
      </div>
      <div *ngIf="popupSetting.type !== PopupSettingType.IMAGE_LIBRARY" class="sub-title">
        Select an existing logo from the library
      </div>
      <div class="logos row" (scroll)="onScroll($event)">
        <div
          class="logo col"
          *ngFor="let logo of defaultImages"
          [class.selectedImage]="logo.isActive"
          [class.disabled-image]="logo.isDisabled"
        >
          <div class="logo-img" [class.active]="logo.id === selectedlogo.id">
            <span (click)="showMore(logo.id)" class="user-more-icon"
              ><img src="assets/images/user-more-icon.svg" alt="user-more-icon"
            /></span>
            <div *ngIf="isShowMoreOption && isCurrentLogoid === logo.id" class="show-more-option p-2">
              <span class="del-btn" (click)="deleteLogo(logo.id)">delete</span>
              <span *ngIf="logo.category === imageType.LOGO" (click)="setGlobalLogo(logo.id)"
                >Set as logo</span
              >
            </div>

            <img (click)="selectLogo(logo)" [src]="logo.path" alt="{{ logo.filename }}" />

            <img
              *ngIf="logo.global_status"
              class="global-icon"
              alt="global-icon"
              src="assets/images/global-logo.svg"
            />
          </div>

          <div class="img-text">
            <h6 [title]="logo.filename">{{ logo.filename }}</h6>
            <p>{{ logo.created_at | date : 'MMM dd, yyyy hh:mm' }}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="files?.length" class="files-list-wrapper custom-scrollbar">
      <div class="file" *ngFor="let file of files; index as idx">
        <div class="icon">
          <img src="/assets/images/image-file-thumbnail.svg" alt="thumb" class="img-fluid" />
        </div>
        <div class="file-details">
          <div class="file-name" [ngClass]="file?.hasSizeError ? 'error' : ''">
            <h3>{{ file.name }}</h3>
            <span class="progress" *ngIf="!file?.hasSizeError && !processingImages">
              {{ uploadProgress !== 100 ? uploadProgress + '%' : 'Complete' }}
            </span>
            <span class="progress" *ngIf="processingImages">
              <img src="/assets/images/loading-icon.svg" alt="loading" />&nbsp;Processing
            </span>
            <span class="progress" *ngIf="file?.hasSizeError && !processingImages">Failed</span>
          </div>
          <div class="progress d-flex">
            <progress id="file" [value]="uploadProgress" max="100"></progress>
          </div>
        </div>
        <div class="menu-wrap" (click)="toggleMenu(idx)">
          <img src="/assets/images/ellipsis-v.svg" alt="thumb" class="img-fluid" />
          <div *ngIf="showIndividualMenu[idx]" class="drop-menu">
            <span (click)="removeImage(idx); removeErrorMsg(file.name, idx)">Remove</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup-footer">
    <button (click)="closePopup('cancel')">Cancel</button>
    <button class="positive" (click)="closePopup('done')">Done</button>
  </div>
</div>
} @else if (popupSetting.type === PopupSettingType.ICON_LIBRARY) {
<finxone-workflow-frontend-icon-upload-popup
  [popupSetting]="popupSetting"
></finxone-workflow-frontend-icon-upload-popup>
}
